export default __webpack_public_path__ + "static/media/logo.a80aa10f.png";